export default "__VITE_ASSET__DdeuTr4A__"